export default {
    user: {
        authenticated: false,
        token: null,
        email: '',
        first_name: '',
        last_name: '',
        uid: '',
        tokenTimeout: false,
    },
    clearingModels: false,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/concretejs/store/module-auth/state.js
// module id = null
// module chunks = 